import React from "react";
import TextField from "@mui/material/TextField";
import { AiOutlineExclamation } from "react-icons/ai";
import { useRouter } from "next/router";
import useQuestionsForm from "hooks/forms/useQuestionsForm";
import Button from "components/button/Button";

import useDarkMode from "hooks/useDarkMode";

const Questions = () => {
  const router = useRouter();
  const { values, errors, submitForm, setFieldValue } = useQuestionsForm();
  const { theme } = useDarkMode();
  const isDark = theme === "dark";

  return (
    <div className="flex flex-col gap-[24px] md:p-[48px] text-center w-full md:w-[600px]">
      <span
        className={`text-[24px] font-sans font-black tracking-tighter ${
          isDark
            ? "text-cyan-50 drop-shadow-[0_0_8px_rgba(255,255,255,0.3)]"
            : "text-cyan-900"
        }`}
      >
        Հարցեր կամ բողոքների համար՝
      </span>
      <div
        className={`flex flex-col gap-[18px] p-[24px] rounded-[24px] transition-all duration-300 ${
          isDark
            ? "bg-[#030014]/60 backdrop-blur-xl border border-cyan-500/20 shadow-[0_0_20px_rgba(102,133,255,0.05)]"
            : "bg-white/80 backdrop-blur-md border border-cyan-600/15 shadow-[0_4px_30px_rgba(8,145,178,0.08)]"
        }`}
      >
        <TextField
          placeholder="Անուն"
          fullWidth
          value={values.name}
          onChange={(e) => setFieldValue("name", e.target.value)}
        />

        <TextField
          placeholder="Էլ․ հասցե"
          type="email"
          autoComplete="off"
          fullWidth
          value={values.email}
          onChange={(e) => setFieldValue("email", e.target.value)}
        />

        <TextField
          placeholder="Հաղորդագրություն"
          fullWidth
          multiline
          rows={3}
          value={values.message}
          onChange={(e) => setFieldValue("message", e.target.value)}
        />
        <div
          className={`flex justify-start items-center p-[12px] gap-[10px] rounded-[14px] ${
            isDark
              ? "bg-cyan-950/20 border border-cyan-500/20"
              : "bg-cyan-50 border border-cyan-200/70"
          }`}
        >
          <div
            className={`w-[40px] h-[40px] flex items-center justify-center rounded-[12px] shrink-0 ${
              isDark
                ? "bg-cyan-500/20 shadow-[0_0_10px_rgba(102,133,255,0.2)] text-cyan-400"
                : "bg-cyan-100 text-cyan-600"
            }`}
          >
            <AiOutlineExclamation size={18} />
          </div>
          <span
            className={`text-[14px] w-fit text-left leading-relaxed ${
              isDark ? "text-slate-300" : "text-slate-600"
            }`}
          >
            Ուղարկելով հաղորդագրություն՝ դուք համաձայնվում եք մեր{" "}
            <button
              onClick={() => router.push("/privacy-policy")}
              className={`underline cursor-pointer transition-colors ${
                isDark
                  ? "text-cyan-400 hover:text-cyan-300"
                  : "text-cyan-600 hover:text-cyan-700"
              }`}
            >
              գաղտնիության քաղաքականությանը{" "}
            </button>{" "}
            և ընդունում եք{" "}
            <button
              onClick={() => router.push("/terms-of-use")}
              className={`underline cursor-pointer transition-colors ${
                isDark
                  ? "text-cyan-400 hover:text-cyan-300"
                  : "text-cyan-600 hover:text-cyan-700"
              }`}
            >
              պայմաններն ու դրույթները
            </button>
          </span>
        </div>
        <Button onClick={() => submitForm()} className="w-full text-lg mt-2">
          Ուղարկել
        </Button>
        {Boolean(errors.name) && (
          <div
            className={`flex justify-start items-center p-[12px] gap-[10px] rounded-[14px] ${
              isDark
                ? "bg-red-950/20 border border-red-500/20"
                : "bg-red-50 border border-red-200"
            }`}
          >
            <div
              className={`w-[40px] h-[40px] flex items-center justify-center rounded-[12px] shrink-0 ${
                isDark
                  ? "text-red-400 bg-red-500/20 shadow-[0_0_10px_rgba(239,68,68,0.2)]"
                  : "text-red-500 bg-red-100"
              }`}
            >
              <AiOutlineExclamation size={18} />
            </div>
            <span
              className={`text-[14px] w-fit text-left ${isDark ? "text-red-200" : "text-red-600"}`}
            >
              {errors.name}
            </span>
          </div>
        )}
        {Boolean(errors.email) && (
          <div
            className={`flex justify-start items-center p-[12px] gap-[10px] rounded-[14px] ${
              isDark
                ? "bg-red-950/20 border border-red-500/20"
                : "bg-red-50 border border-red-200"
            }`}
          >
            <div
              className={`w-[40px] h-[40px] flex items-center justify-center rounded-[12px] shrink-0 ${
                isDark
                  ? "text-red-400 bg-red-500/20 shadow-[0_0_10px_rgba(239,68,68,0.2)]"
                  : "text-red-500 bg-red-100"
              }`}
            >
              <AiOutlineExclamation size={18} />
            </div>
            <span
              className={`text-[14px] w-fit text-left ${isDark ? "text-red-200" : "text-red-600"}`}
            >
              {errors.email}
            </span>
          </div>
        )}
        {Boolean(errors.message) && (
          <div
            className={`flex justify-start items-center p-[12px] gap-[10px] rounded-[14px] ${
              isDark
                ? "bg-red-950/20 border border-red-500/20"
                : "bg-red-50 border border-red-200"
            }`}
          >
            <div
              className={`w-[40px] h-[40px] flex items-center justify-center rounded-[12px] shrink-0 ${
                isDark
                  ? "text-red-400 bg-red-500/20 shadow-[0_0_10px_rgba(239,68,68,0.2)]"
                  : "text-red-500 bg-red-100"
              }`}
            >
              <AiOutlineExclamation size={18} />
            </div>
            <span
              className={`text-[14px] w-fit text-left ${isDark ? "text-red-200" : "text-red-600"}`}
            >
              {errors.message}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Questions;
